import { ICheckBoxListModels } from "./SelectModelsInterfaces";
import { Row, Col } from "react-bootstrap";
import CheckBoxList from "../generic_components/CheckBoxList";
import { useEffect, useState } from "react";
import { ComponentStruct } from "../../common/Interfaces";

export default function CheckBoxListModels({
  onChange,
  onChecked,
  options,
  selected,
  archivedCheckbox = true,
  show = true,
  selectAll = false,
}: ICheckBoxListModels) {
  const [showArchivedCheckbox, setShowArchivedCheckbox] = useState(false);

  useEffect(() => {
    if (selectAll && options.length > 0) {
      setShowArchivedCheckbox(true);
    }
  }, [selectAll, options]);

  const handleCheckboxChange = (checked: boolean) => {
    setShowArchivedCheckbox(checked);
    if (onChecked) {
      onChecked(checked);
    }
  };

  const handleSelectedChange = (selectedItems: ComponentStruct[] | null) => {
    onChange(selectedItems || []);
  };
  if (!show) {
    return <></>;
  }
  return (
    <Row className="padding-top">
      <Col xs={3}>
        <label>{archivedCheckbox ? "Models" : "Archived Models"}</label>
      </Col>
      <Col xs={9}>
        <CheckBoxList
          options={options}
          selected={selected}
          archivedCheckbox={archivedCheckbox}
          checked={showArchivedCheckbox}
          selectAll={selectAll}
          onChecked={handleCheckboxChange}
          onChange={handleSelectedChange}
        />
      </Col>
    </Row>
  );
}
